import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import moment from "moment";
import Icon from "../Common/Icon";
import actions from "../../actions/stop";
import LineBadge from "./LineBadge";
class Departures extends Component {
  constructor() {
    super();
    this.state = {
      showMore: false,
      startedRefreshing: false,
      wasRefreshing: false,
    };
  }

  showMoreToggle = () => {
    this.setState({
      showMore: !this.state.showMore,
    });
  };

  startRefreshInterval = () => {
    const { config } = this.props;
    let { refreshTimeInMilliseconds } = config || {};
    const delayInMilliseconds = refreshTimeInMilliseconds || 25000;

    this.props.startRefreshInterval(delayInMilliseconds, false);
  };

  abortRefreshInterval = () => {
    this.props.abortRefreshInterval();
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const { stop, refreshing } = this.props;
    if (!stop || !refreshing) return;

    this.setState({
      startedRefreshing: true,
    });
  }

  componentDidUpdate() {
    const { stop, loading } = this.props;

    if (stop) {
      this.startRefreshInterval();
    } else {
      this.abortRefreshInterval();
    }

    if (!loading && this.state.startedRefreshing) {
      this.setState({
        startedRefreshing: false,
        wasRefreshing: true,
      });
      setTimeout(() => {
        this.setState({
          wasRefreshing: false,
        });
      }, 1000);
    }
  }

  componentWillUnmount() {
    this.abortRefreshInterval();
  }

  render() {
    const { wasRefreshing, showMore, config } = this.state;
    const {
      refreshing,
      stop,
      dataTimestamp,
      config: {
        locale = "en-gb",
        refreshText = "(wordt iedere 25 seconden ververst)",
        noDeparturesText = "Bij deze halte vertrekken de komende tijd geen bussen.",
        titleText = "Actuele vertrektijden",
        lineHeaderText = "Lijn",
        directionHeaderText = "Richting",
        departureTimeHeaderText = "Vertrek",
        departureTimeScreenReaderText = "Vertrekt",
        departureTimeText = "over {0} min",
        departureNowText = "De bus vertrekt nu",
        lineLinkBaseUrl = "/",
        lineNumberText = "Ga naar lijnnummer",
        showMoreText = "Bekijk meer vertrektijden",
        showLessText = "Bekijk minder vertrektijden",
      },
    } = this.props;
    if (!stop) return null;

    moment.locale(locale);
    const { departures = [] } = stop;
    return (
      <div
        className={`halte-departures ${
          wasRefreshing ? "halte-departures--loading" : ""
        }`}
      >
        <div className="halte-sub-header">
          <div className="container container--center container--margin">
            <h2 className="halte-sub-header__title">
              <span className="halte-sub-header__icon">
                <Icon iconName="clockbig" />
              </span>
              {titleText}
            </h2>
            <div className="halte-sub-header__info">
              <div className="halte-sub-header__name">
                {stop.town}, {stop.name}
              </div>
              <div className="halte-sub-header__timestamp">
                <div className="halte-sub-header__timestamp-remark">
                  {refreshText}
                </div>
                {wasRefreshing || refreshing ? (
                  <Icon
                    className="halte-sub-header__loading-icon mobile-hide"
                    iconName="loading-light"
                  />
                ) : null}
                {moment(dataTimestamp).format("dddd")}{" "}
                <b>{moment(dataTimestamp).format("HH:mm")}</b>
                {wasRefreshing || refreshing ? (
                  <Icon
                    className="halte-sub-header__loading-icon mobile-only"
                    iconName="loading-light"
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="halte-departures">
          <ul className="halte-departures__list">
            <div className="halte-departures__header">
              <hr className="line line--no-margin" />
              <div className="container container--center">
                <div className="halte-departures__header-row">
                  <div className="halte-departures__line-numbers">
                    {lineHeaderText}
                  </div>
                  <div className="halte-departures__direction">
                    {directionHeaderText}
                  </div>
                  <div className="halte-departures__departure-time">
                    {departureTimeHeaderText}
                  </div>
                </div>
              </div>
            </div>

            {!departures.length ? (
              <div className="halte-departures__empty">
                <div className="container container--center">
                  <div className="halte-departures__empty-text">
                    {noDeparturesText}
                  </div>
                </div>
              </div>
            ) : (
              departures.map((departure, index) => {
                if (!showMore && index >= 8) return null;

                const {
                  departure_time,
                  realtime_departure_time,
                  tripdata = {},
                  trip_id,
                  stop_headsign,
                  schedule_relationship,
                } = departure;

                const { route_id, trip_headsign, direction_id } = tripdata;
                const {
                  route_color,
                  route_text_color,
                  route_short_name,
                  route_long_name,
                  line_planning_number,
                } = tripdata.route || {};

                /* if(realtime_departure_time && departure_time) {
                    if(parseInt(realtime_departure_time) != parseInt(departure_time)) {
                      console.log('Andere realtime tijd', parseInt(realtime_departure_time), parseInt(departure_time))
                    }
                  } */
                const departureTime = moment.unix(
                  realtime_departure_time || departure_time
                );
                const tillDeparture = moment.duration(
                  departureTime.diff(moment(dataTimestamp))
                );
                const tillDepartureInMinutes = Math.floor(
                  tillDeparture.asMinutes()
                );

                let departureTimeFormattedText = null;
                if (tillDepartureInMinutes <= 0) {
                  departureTimeFormattedText =
                    schedule_relationship === "SKIPPED" ? (
                      <Icon
                        iconName="bus-arriving-cancelled"
                        title={departureNowText}
                      />
                    ) : (
                      <Icon iconName="bus-arriving" title={departureNowText} />
                    );
                } else if (tillDepartureInMinutes < 60) {
                  departureTimeFormattedText = departureTimeText.replace(
                    "{0}",
                    tillDepartureInMinutes
                  );
                } else {
                  departureTimeFormattedText = departureTime.format("HH:mm");
                }

                return (
                  <li key={trip_id} className="halte-departures__item">
                    <div className="container container--center">
                      <div className="halte-departures__item-content">
                        <div className="halte-departures__line-numbers">
                          <b className="mobile-only">
                            {lineHeaderText}
                            <br />
                          </b>
                          <div className="halte-departures__inline_icons">
                            <LineBadge
                              route_id={route_id}
                              route_short_name={route_short_name}
                              route_long_name={route_long_name}
                              accessibilityPrefixText={lineNumberText}
                              text={route_short_name}
                              baseUrl={lineLinkBaseUrl}
                              route_text_color={route_text_color}
                              route_color={route_color}
                            />
                            <div className="dienstregeling__halte-icons">
                              {schedule_relationship === "SKIPPED" && (
                                <Icon
                                  className="dienstregeling__halte-storing-icon-departures"
                                  iconName="storingen"
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          className="halte-departures__direction_disrupted"
                          tabIndex="0"
                        >
                          <b className="mobile-only">
                            {directionHeaderText}
                            <br />
                          </b>
                          <span className="sr-only">{directionHeaderText}</span>
                          {stop_headsign || "Unknown direction"}
                        </div>
                        <div
                          className="halte-departures__departure-time"
                          tabIndex="0"
                        >
                          <b className="mobile-only" aria-hidden="true">
                            {departureTimeHeaderText}
                            <br />
                          </b>
                          <span className="sr-only">
                            {departureTimeScreenReaderText}
                          </span>
                          <div
                            className={`${
                              schedule_relationship === "SKIPPED"
                                ? "dienstregeling__time-block--cancelled"
                                : ""
                            }`}
                          >
                            {departureTimeFormattedText}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })
            )}
          </ul>
          {departures.length <= 8 ? null : (
            <div className="container container--center">
              <button
                className="btn--reset link halte-departures__toggle-more-btn"
                onClick={this.showMoreToggle}
              >
                {!showMore ? showMoreText : showLessText} {showMore ? `-` : `+`}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  ({ stop: { data, loading, refreshing, dataTimestamp } }) => {
    return {
      stop: data,
      loading,
      refreshing,
      dataTimestamp,
    };
  },
  {
    request: actions.request(),
    startRefreshInterval: actions.startRefreshInterval,
    abortRefreshInterval: actions.abortRefreshInterval,
  }
)(Departures);



// WEBPACK FOOTER //
// ./src/components/Haltes/Departures.js